// app/translate/translation.ts

import { OpaqueToken } from '@angular/core';

// import translations
import { LANG_EN_NAME, LANG_EN_TRANS } from './lang-en';
import { LANG_NL_NAME, LANG_NL_TRANS } from './lang-nl';
import { LANG_DE_NAME, LANG_DE_TRANS } from './lang-de';
import { LANG_ES_NAME, LANG_ES_TRANS } from './lang-es';
import { LANG_PT_NAME, LANG_PT_TRANS } from './lang-pt';
import { LANG_FR_NAME, LANG_FR_TRANS } from './lang-fr';
import { LANG_PL_NAME, LANG_PL_TRANS } from './lang-pl';

// translation token
export const TRANSLATIONS = new OpaqueToken('translations');

// all traslations
const dictionary = {
  [LANG_EN_NAME]: LANG_EN_TRANS,
  [LANG_NL_NAME]: LANG_NL_TRANS,
  [LANG_DE_NAME]: LANG_DE_TRANS,
  [LANG_ES_NAME]: LANG_ES_TRANS,
  [LANG_PT_NAME]: LANG_PT_TRANS,
  [LANG_FR_NAME]: LANG_FR_TRANS,
  [LANG_PL_NAME]: LANG_PL_TRANS,
};

// providers
export const TRANSLATION_PROVIDERS = [
  { provide: TRANSLATIONS, useValue: dictionary },
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/translate/translations.ts